export default __webpack_public_path__ + "static/media/thriving-btn.f3547128.svg";